import type { WorkSessionResponse } from '@gamble-chess/contracts';
import type { JSX } from 'react';

import { describeWorkSession, formatDateTime } from '../format.ts';
import { Entry, EntryList } from '../ui/EntryList.tsx';
import { hintClass, labelClass } from '../ui/styles.ts';

export interface WorkLogProps {
  readonly sessions: readonly WorkSessionResponse[];
  /** How many of the newest sessions to show; all of them when left out. */
  readonly limit?: number;
  /** A caption, where the card around the log is about something else. */
  readonly caption?: string;
}

/** Finished sessions in words, so a reader can see their work was counted. */
export function WorkLog({ sessions, limit, caption }: WorkLogProps): JSX.Element {
  if (sessions.length === 0) {
    return <p className={hintClass}>No work logged yet.</p>;
  }

  return (
    <div className="flex flex-col gap-1">
      {caption === undefined ? null : <h3 className={labelClass}>{caption}</h3>}
      <EntryList label="Recent work">
        {(limit === undefined ? sessions : sessions.slice(0, limit)).map((session) => (
          <Entry
            key={session.id}
            lead={describeWorkSession(session)}
            meta={<span className={hintClass}>{formatDateTime(session.startedAt)}</span>}
          />
        ))}
      </EntryList>
    </div>
  );
}
